export const FormStructure = (isEdit) => {
  return [
    {
      id: "1",
      type: "inputBox",
      title: "Product Name",
      name: "product_name",
      // options: ["Portrait", "Landscape"],
      required: true,
    },
    // {
    //   id: "2",
    //   type: "inputBox",
    //   title: "Description",
    //   name: "product_description",
    //   // options: ["Portrait", "Landscape"],
    //   required: true,
    // },
    {
      id: "2",
      type: "select",
      title: "Unit of Measure",
      name: "unit_of_measure",
      options: ["BAGS(BAG)", "BALE(BAL)"],
      required: true,
    },
    {
      id: "3",
      type: "select",
      title: "Gst Rate (%)",
      name: "gst_rate",
      options: ["12", "18"],
      required: true,
    },
    // {
    //   id: "3",
    //   type: "select",
    //   title: "Product Category",
    //   name: "product_category",
    //   options: ["Category 1", "Category 2", "Category 3"],
    //   required: true,
    // },
    {
      id: "4",
      type: "inputBox",
      title: "HSN",
      name: "HSN",
      required: true,
      // regex: /^[0-9\s\&]/,
      // disabled: true
    },
    // {
    //   id: "5",
    //   type: "inputBox",
    //   title: "Cost",
    //   name: "cost",
    //   required: true,
    //   regex: /^[0-9\s\&]/,
    //   // disabled: true
    // },

    {
      id: "5",
      type: "inputBox",
      title: "Purchase Price",
      name: "purchase_price",
      required: true,
      regex: /^[0-9\s\&]/,
      // disabled: true
    },

    {
      id: "6",
      type: "inputBox",
      title: "Selling Price",
      name: "selling_price",
      required: true,
      regex: /^[0-9\s\&]/,
      // disabled: true
    },

    // {
    //   id: "7",
    //   type: "inputBox",
    //   title: "Price",
    //   name: "price",
    //   required: true,
    //   regex: /^[0-9\s\&]/,
    //   // disabled: true
    // },

    {
      id: "7",
      type: "toggle",
      title: "Status",
      name: "status",
      default: "Active",
      size: "12",
      options: [
        { value: "Active", color: "success" },
        { value: "Inactive", color: "danger" },
      ],
    },
    {
      id: "8",
      type: "button",
      title: isEdit ? "Edit" : "Create",
    },
  ];
};
